<div class="flex h-dvh w-full max-w-full flex-col overflow-x-hidden overflow-y-auto bg-sem-surface-subtle">
  @if (appChromeVisible()) {
    <app-header />
  }

  <main
    class="relative flex-1 min-h-0 min-w-0 overflow-x-hidden overflow-y-hidden mx-0 sm:mx-8 xl:mx-16"
    [class.mx-0]="!appChromeVisible()"
    [class.sm:mx-16]="appChromeVisible()"
  >
    @if (useElevatedContentSurface() && appChromeVisible()) {
      <div
        aria-hidden="true"
        class="pointer-events-none absolute inset-x-0 -top-4 -bottom-8 rounded-sm bg-sem-surface-default shadow-sm"
      ></div>

      <section class="relative h-full min-w-0 overflow-x-hidden overflow-y-auto p-6">
        <router-outlet />
      </section>
    } @else {
      <section class="h-full min-w-0 overflow-x-hidden overflow-y-auto">
        <router-outlet />
      </section>
    }
  </main>

  @if (appChromeVisible()) {
    <app-footer />
  }
</div>
